import React from "react";
import AuditoriaLayout from "../layouts/AuditoriaLayout";

export default function AuditoriaPage() {
  return <AuditoriaLayout />;
}
